import { PlatformUtils_getInstance8t6iqcjia1rj as PlatformUtils_getInstance } from '../PlatformUtils.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___get_value__impl__bjfvqg316j9v81zgqwq as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2lptaeb4c2198 as _Result___get_isFailure__impl__jpiriv,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  get_entries3rhsgvbgx7tis as get_entries,
  LogLevel_INFO_getInstanceot8m8b9fpgo1 as LogLevel_INFO_getInstance,
  LogLevel_TRACE_getInstance2lc1sj4z7ggru as LogLevel_TRACE_getInstance,
  LogLevel_WARN_getInstanceiqe06k3zdc7k as LogLevel_WARN_getInstance,
  LogLevel_DEBUG_getInstance20oo5rmjkm3m2 as LogLevel_DEBUG_getInstance,
} from './Logger.web.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function KtorSimpleLogger(name) {
  return new (KtorSimpleLogger$1())();
}
function getKtorLogLevel() {
  return process ? process.env.KTOR_LOG_LEVEL : null;
}
var KtorSimpleLogger$1Class;
function KtorSimpleLogger$1() {
  if (KtorSimpleLogger$1Class === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        var tmp_0;
        switch (PlatformUtils_getInstance().i4p_1 || PlatformUtils_getInstance().h4p_1) {
          case true:
            // Inline function 'kotlin.runCatching' call

            var tmp_1;
            try {
              // Inline function 'kotlin.Companion.success' call
              var value = getKtorLogLevel();
              tmp_1 = _Result___init__impl__xyqfz8(value);
            } catch ($p) {
              var tmp_2;
              if ($p instanceof Error) {
                var e = $p;
                // Inline function 'kotlin.Companion.failure' call
                tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
              } else {
                throw $p;
              }
              tmp_1 = tmp_2;
            }

            // Inline function 'kotlin.Result.getOrNull' call

            var this_0 = tmp_1;
            var tmp1_safe_receiver = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
            var tmp_3;
            if (tmp1_safe_receiver == null) {
              tmp_3 = null;
            } else {
              // Inline function 'kotlin.let' call
              var tmp0 = get_entries();
              var tmp$ret$7;
              $l$block: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var _iterator__ex2g4s = tmp0.p1();
                while (_iterator__ex2g4s.q1()) {
                  var element = _iterator__ex2g4s.r1();
                  if (element.v1_1 === tmp1_safe_receiver) {
                    tmp$ret$7 = element;
                    break $l$block;
                  }
                }
                tmp$ret$7 = null;
              }
              tmp_3 = tmp$ret$7;
            }

            var tmp2_elvis_lhs = tmp_3;
            tmp_0 = tmp2_elvis_lhs == null ? LogLevel_INFO_getInstance() : tmp2_elvis_lhs;
            break;
          case false:
            tmp_0 = LogLevel_TRACE_getInstance();
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp.z4t_1 = tmp_0;
      }
      a4u() {
        return this.z4t_1;
      }
      b4u(message) {
        if (this.z4t_1.d5(LogLevel_WARN_getInstance()) > 0)
          return Unit_instance;
        console.warn(message);
      }
      c4u(message, cause) {
        if (this.z4t_1.d5(LogLevel_DEBUG_getInstance()) > 0)
          return Unit_instance;
        console.debug('DEBUG: ' + message + ', cause: ' + cause.toString());
      }
      d4u(message) {
        if (this.z4t_1.d5(LogLevel_TRACE_getInstance()) > 0)
          return Unit_instance;
        console.debug('TRACE: ' + message);
      }
    }
    initMetadataForClass($);
    KtorSimpleLogger$1Class = $;
  }
  return KtorSimpleLogger$1Class;
}
//region block: exports
export {
  KtorSimpleLogger as KtorSimpleLogger1xdphsp5l4e48,
};
//endregion

//# sourceMappingURL=KtorSimpleLogger.web.mjs.map
